import { ServiceMaker, methods, services } from "@/services";

export const listfaq = () =>
  ServiceMaker(`/servicerequest/list-faq`, methods.GET, services.master);

export const createFaq = (data) =>
  ServiceMaker(`/servicerequest/faq`, methods.POST, services.master, data);

export const updateFaq = (id, data) =>
  ServiceMaker(`/servicerequest/faq/${id}`, methods.PUT, services.master, data);

export const deleteFaq = (id) =>
  ServiceMaker(`/servicerequest/faq/${id}`, methods.DELETE, services.master);

export const faqs = (scope) =>
  ServiceMaker(
    `/servicerequest/filter-faq?scope=${scope}&query=`,
    methods.GET,
    services.master
  );
